module.exports = __webpack_public_path__ + "static/img/contant_2.0afbe14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_12/contant_2.jpg
// module id = TS0s
// module chunks = 0